export default __webpack_public_path__ + "7bffd26f98fcaa0c4e3a018e42b2b2fe.png";